import uniq from 'lodash/uniq';

const getUpdatedUniqueItems = (oldItems, newItems = []) => {
  const actualUpdatedItems = newItems.filter((state) => {
    let notChanged = false;
    oldItems.forEach((oldState) => {
      if (oldState === state) {
        notChanged = true;
      }
    });
    return !notChanged;
  });
  return actualUpdatedItems;
};

const getUpdatedUniqueItemIds = (oldItems, newItems = [], idKeyName) => {
  const actualUpdatedItems = getUpdatedUniqueItems(oldItems, newItems);

  const updatedStateIds = actualUpdatedItems.map(item => item[idKeyName]);
  return uniq(updatedStateIds);
};

const getUpdatedItemsByIndex = (oldItems, newItems) => newItems.filter((n, i) => n !== oldItems[i]);
const getUpdatedItemIdsByIndex = (oldItems, newItems, key) => uniq(getUpdatedItemsByIndex(oldItems, newItems).map(item => item[key]));

export {
  getUpdatedUniqueItemIds,
  getUpdatedUniqueItems,
  getUpdatedItemsByIndex,
  getUpdatedItemIdsByIndex
};
